import React from 'react';
import { TriangleAlert } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

const OrphanSiteWarningBanner: React.FC = () => (
  <Alert
    className="mb-6 border-warning-300 bg-warning-50 text-warning-900"
    data-testid="orphan-site-warning-banner"
  >
    <TriangleAlert className="text-warning-600" />
    <AlertTitle>No study linked to this submission</AlertTitle>
    <AlertDescription className="text-warning-800">
      <span>
        This submission won&apos;t be associated with a study. If you are
        submitting for a site that is part of a multi-site study, ask your
        Sponsor/CRO/Coordinating Center contact to send you an invitation —
        or, if you manage the study yourself, add the site from there
        instead.
      </span>
    </AlertDescription>
  </Alert>
);

export default OrphanSiteWarningBanner;
